const fields = {
  config: {
    columns: 1
  },
  fields: [
    {
      name: "id",
      column: 1,
      type: "unvisible"
    },
    {
      name: 'house',
      label: 'Domek',
      column: 1,
      mandatory: true,
      type: 'dictionary',
      dictionary: 'house',
    },
    {
      name: "title",
      label: "Powód",
      column: 1,
      type: "text",
      mandatory: true
    },
    {
      name: 'dates',
      label: 'Dni zablokowane od - do',
      column: 1,
      type: 'dateRange',
      mandatory: true,
      startField: 'startDate',
      endField: 'endDate',
      excludedDates: [],
      excludedStartDates: [],
      excludedEndDates: [],
      fromLabel: 'Data startu',
      toLabel: 'Data końca',
    },
  ]
};

export default fields;
